<div class="rounded-[12px] border border-neutral-200">
    <!-- Toggle Header -->
    <button (click)="toggleAiPanel()"
        class="w-full flex items-center justify-between px-4 py-3 bg-neutral-50 hover:bg-neutral-100 transition-colors cursor-pointer"
        [ngClass]="aiPanelOpen ? 'rounded-t-[12px]' : 'rounded-[12px]'">
        <div class="flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-primary-700" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 2a4 4 0 0 1 4 4c0 1.95-1.4 3.58-3.25 3.93L12 22" />
                <path d="M12 2a4 4 0 0 0-4 4c0 1.95 1.4 3.58 3.25 3.93" />
                <path d="M8.56 13a8 8 0 0 0-2.3 2.13" />
                <path d="M15.44 13a8 8 0 0 1 2.3 2.13" />
                <path d="M12 18a4.5 4.5 0 0 0-4.32 3.17" />
                <path d="M12 18a4.5 4.5 0 0 1 4.32 3.17" />
            </svg>
            <span class="font-medium text-sm text-neutral-700">{{ 'admin.qa.qa_tools' | transloco }}</span>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-neutral-400 transition-transform"
            [ngClass]="{ 'rotate-180': aiPanelOpen }" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
    </button>

    <!-- Panel Content -->
    <div *ngIf="aiPanelOpen" class="px-4 py-4 flex flex-col gap-4 border-t border-neutral-200">
        <!-- Comparison Selector + Actions Row -->
        <div class="flex flex-wrap items-end gap-3">
            <div class="w-[200px]">
                <app-custom-dropdown [options]="compareDropdownOptions" [(selectedOption)]="selectedCompareIndex"
                    label="{{ 'admin.qa.ai_compare_mode' | transloco }}">
                </app-custom-dropdown>
            </div>

            <button (click)="generateAiSummary()" [disabled]="aiSummaryLoading"
                class="btn bg-primary-700 hover:bg-primary-800 text-white border-none rounded-[8px] gap-1.5 h-[48px] min-h-[48px] px-4 text-sm disabled:opacity-50">
                <svg *ngIf="!aiSummaryLoading" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2a4 4 0 0 1 4 4c0 1.95-1.4 3.58-3.25 3.93L12 22" />
                    <path d="M12 2a4 4 0 0 0-4 4c0 1.95 1.4 3.58 3.25 3.93" />
                </svg>
                <span *ngIf="aiSummaryLoading" class="loading loading-spinner loading-xs"></span>
                {{ 'admin.qa.ai_generate_summary' | transloco }}
            </button>

            <button (click)="generateAiPrompt()"
                class="btn bg-neutral-200 hover:bg-neutral-300 text-neutral-700 border-none rounded-[8px] gap-1.5 h-[48px] min-h-[48px] px-4 text-sm">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
                {{ 'admin.qa.ai_generate_prompt' | transloco }}
            </button>

            <button (click)="exportComparisonCSV()"
                class="btn bg-neutral-200 hover:bg-neutral-300 text-neutral-700 border-none rounded-[8px] gap-1.5 h-[48px] min-h-[48px] px-4 text-sm">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                {{ 'admin.qa.ai_export_csv' | transloco }}
            </button>
        </div>

        <!-- AI Summary Result -->
        <div *ngIf="aiSummary" class="bg-primary-50 rounded-[8px] p-4 flex flex-col gap-3">
            <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-primary-700">{{ 'admin.qa.ai_summary_result' | transloco }}</span>
                <button (click)="copySummaryToClipboard()"
                    class="btn btn-xs bg-primary-100 hover:bg-primary-200 text-primary-700 border-none rounded-[6px] gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                    {{ 'admin.copy' | transloco }}
                </button>
            </div>
            <p class="text-sm text-neutral-700 whitespace-pre-line">{{ aiSummary }}</p>

            <div *ngIf="aiHighlights.length" class="flex flex-col gap-1">
                <span class="text-xs font-medium text-primary-600 uppercase">{{ 'admin.qa.ai_highlights' | transloco
                    }}</span>
                <ul class="list-disc list-inside text-sm text-neutral-600">
                    <li *ngFor="let h of aiHighlights">{{ h }}</li>
                </ul>
            </div>

            <div *ngIf="aiRecommendations.length" class="flex flex-col gap-1">
                <span class="text-xs font-medium text-primary-600 uppercase">{{ 'admin.qa.ai_recommendations' |
                    transloco }}</span>
                <ul class="list-disc list-inside text-sm text-neutral-600">
                    <li *ngFor="let r of aiRecommendations">{{ r }}</li>
                </ul>
            </div>
        </div>

        <!-- Generated Prompt Result -->
        <div *ngIf="generatedPrompt" class="bg-neutral-50 rounded-[8px] p-4 flex flex-col gap-2">
            <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-neutral-700">{{ 'admin.qa.ai_generated_prompt' | transloco
                    }}</span>
                <button (click)="copyPromptToClipboard()"
                    class="btn btn-xs bg-neutral-200 hover:bg-neutral-300 text-neutral-700 border-none rounded-[6px] gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                    {{ 'admin.copy' | transloco }}
                </button>
            </div>
            <pre
                class="text-xs text-neutral-600 bg-white rounded-[6px] p-3 border border-neutral-200 overflow-x-auto whitespace-pre-wrap max-h-[300px] overflow-y-auto">{{ generatedPrompt }}</pre>
        </div>
    </div>
</div>